//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "eassyinfo",
  components: {
  },
  props: {
    //业务数据
    record: { type: Object, default: () => ({}) },
    //流程数据
    process: { type: Object, default: () => ({}) },
    //规则绑定
    rules: { type: Object, default: () => ({}) },
    //自定义的参数
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {

    };
  },
  methods: {

  },
  created() {},
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/resumeApply/eassyinfo.vue